export default class VulnerabilitiesFiltersViewModel {
    isActive: boolean = false
    vulnerability: string[] = [];
    vulnerabilityCategory: string[] = [];
}